import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { usePermissions } from "shared";

import { GenerateTokenButtonsProps, RENDER_NAMES } from "../types";

const GenerateTokenButtons = ({
    isLoading,
    isDisabled,
    token,
    resetValue,
    changeRenderName,
    close
}: GenerateTokenButtonsProps) => {
    const { t } = useTranslation();

    const {
        isCreateTokenNotAllowed,
        PERMISSIONS,
        getNoPermissionTooltipTitle
    } = usePermissions();

    return (
        <>
            <Button
                fullWidth
                variant={BUTTON_VARIANTS.TextOnly}
                size={BUTTON_SIZES.Normal}
                color={BUTTON_COLORS.Secondary}
                disabled={isLoading}
                onClick={close}
            >
                {t("Button##close")}
            </Button>

            {token ? (
                <Button
                    fullWidth
                    variant={BUTTON_VARIANTS.TextOnly}
                    size={BUTTON_SIZES.Normal}
                    color={BUTTON_COLORS.Primary}
                    onClick={() => {
                        changeRenderName(RENDER_NAMES.List);
                        resetValue();
                    }}
                >
                    {t("Api tokens##show token list")}
                </Button>
            ) : (
                <TooltipGeneral
                    placement={TOOLTIP_PLACEMENT.Top}
                    title={getNoPermissionTooltipTitle(PERMISSIONS.TokenCreate)}
                >
                    <span>
                        <Button
                            fullWidth
                            variant={BUTTON_VARIANTS.TextOnly}
                            size={BUTTON_SIZES.Normal}
                            color={BUTTON_COLORS.Primary}
                            type="submit"
                            disabled={isCreateTokenNotAllowed || isDisabled}
                            isLoading={isLoading}
                        >
                            {t("Button##generate")}
                        </Button>
                    </span>
                </TooltipGeneral>
            )}
        </>
    );
};

export default GenerateTokenButtons;
